import React, {Component} from 'react';
import {AppContext} from "../../../AppContext";
import axios from "axios";
import {Alert, Button, Col, Form, Row, Spinner} from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Select from "react-select";

class ComplaintsExport extends Component {

    static contextType = AppContext;

    state = {
        customer: null,
        customers: [],
        selectedServiceTypes: [],
        alert: '',
        alertType: 'danger',
        isLoading: false,
        isExporting: false
    }

    componentDidMount() {
        this.loadCustomers();
    }

    loadCustomers = () => {
        this.setState({...this.state, isLoading: true})
        axios.get(`${this.context.hostname}/api/customer/findAll`, {
            headers: {"X-Requested-With": "XMLHttpRequest"},
            withCredentials: true,
        }).then(res => {
            if (res.status === 200) {
                const customers = res.data.map(c => ({
                    value: c.id,
                    label: c.fullName
                }));
                this.setState({
                    customers: customers,
                    isLoading: false,
                    alert: ''
                })
            }
        }).catch((error) => {
            console.log(error)
            this.setState({
                ...this.state,
                customers: [],
                alert: 'Błąd przy pobieraniu listy kontrahentów',
                alertType: 'danger',
                isLoading: false
            })
        });
    }

    handleCustomerChange = (selectedOption) => {
        this.setState({
            ...this.state,
            customer: selectedOption
        })
    }

    handleServiceTypesChange = (selectedOptions) => {
        this.setState({
            ...this.state,
            selectedServiceTypes: selectedOptions || []
        })
    }

    handleExport = () => {
        const {customer, selectedServiceTypes} = this.state;
        const dateFrom = this.context.statistics.searchDateFrom;
        const dateTo = this.context.statistics.searchDateTo;

        if (!dateFrom || !dateTo) {
            this.setState({
                alert: 'Proszę wypełnić datę Od i Do w polach powyżej',
                alertType: 'warning'
            });
            return;
        }

        this.setState({
            ...this.state,
            isExporting: true,
            alert: '',
            alertType: 'danger'
        });

        const startDate = dateFrom + 'T00:00:00';
        const endDate = dateTo + 'T23:59:59';
        const customerId = customer ? customer.value : '';

        const serviceTypesParam = selectedServiceTypes.length > 0
            ? selectedServiceTypes.map(st => '&serviceTypes=' + st.value).join('')
            : '';
        const url = `${this.context.hostname}/api/service/export/complaints?startDate=${startDate}&endDate=${endDate}${customerId ? '&customerId=' + customerId : ''}${serviceTypesParam}`;

        axios.get(url, {
            headers: {"X-Requested-With": "XMLHttpRequest"},
            withCredentials: true,
            responseType: 'blob'
        }).then(res => {
            if (res.status === 200) {
                const blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
                link.setAttribute('download', `Rejestr_reklamacji_${timestamp}.xlsx`);

                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                this.setState({
                    isExporting: false,
                    alert: 'Plik Excel został pomyślnie pobrany',
                    alertType: 'success'
                });
            }
        }).catch((error) => {
            console.log(error);
            this.setState({
                isExporting: false,
                alert: 'Błąd podczas generowania pliku Excel: ' + (error.response?.data?.message || error.message),
                alertType: 'danger'
            });
        });
    }

    handleClearFilters = () => {
        this.setState({
            customer: null,
            selectedServiceTypes: [],
            alert: '',
            alertType: 'danger'
        });
    }

    render() {
        return (
            <>
                {this.state.alert !== '' ?
                    <Alert variant={this.state.alertType} onClose={() => this.setState({alert: ''})} dismissible>
                        {this.state.alert}
                    </Alert> : false}

                <Card>
                    <Card.Header as="h6">
                        Eksport rejestru reklamacji do Excel
                        {this.state.isLoading ? <>&nbsp;<Spinner animation="border" size="sm"/></> : false}
                    </Card.Header>
                    <Card.Body style={{fontSize: 13}}>
                        <Row className="mb-3">
                            <Col md={12}>
                                <div className="alert alert-info" style={{fontSize: 12, padding: '8px 12px'}}>
                                    <strong>Uwaga:</strong> Użyj pól "Data od" i "Data do" powyżej, aby ustawić zakres dat dla eksportu.
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Kontrahent (opcjonalnie)</Form.Label>
                                    <Select
                                        isClearable
                                        isSearchable
                                        value={this.state.customer}
                                        onChange={this.handleCustomerChange}
                                        options={this.state.customers}
                                        placeholder="Wybierz kontrahenta lub zostaw puste dla wszystkich..."
                                        noOptionsMessage={() => "Brak wyników"}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Typ protokołu (opcjonalnie)</Form.Label>
                                    <Select
                                        isMulti
                                        isClearable
                                        value={this.state.selectedServiceTypes}
                                        onChange={this.handleServiceTypesChange}
                                        options={this.context.data.serviceTypes.map(st => ({
                                            value: st.enum,
                                            label: st.name
                                        }))}
                                        placeholder="Wybierz typy protokołów lub zostaw puste dla wszystkich..."
                                        noOptionsMessage={() => "Brak wyników"}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <div className="text-muted small">
                                    <strong>Informacja:</strong> Raport zawiera następujące kolumny:
                                    Nr, Data wpływu, Klient, Maszyna(Nazwa/Model), Numer maszyny,
                                    Data sprzedaży, Typ (Gwarancyjna/Pozagwarancją), Opis, Status oraz pola do wypełnienia ręcznie.
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Button
                                    variant="primary"
                                    onClick={this.handleExport}
                                    disabled={this.state.isExporting || !this.context.statistics.searchDateFrom || !this.context.statistics.searchDateTo}
                                >
                                    {this.state.isExporting ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            {' '}Generowanie...
                                        </>
                                    ) : (
                                        'Eksportuj do Excel'
                                    )}
                                </Button>
                                {' '}
                                <Button
                                    variant="secondary"
                                    onClick={this.handleClearFilters}
                                    disabled={this.state.isExporting}
                                >
                                    Wyczyść filtry
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </>
        );
    }
}

export default ComplaintsExport;